const navLinks = Array.from(document.querySelectorAll("[data-section]"));
const sections = Array.from(document.querySelectorAll("main section[id]"));
const tabTriggers = Array.from(document.querySelectorAll(".tabs-trigger"));
const tabPanels = Array.from(document.querySelectorAll(".tabs-panel"));
const revealItems = Array.from(document.querySelectorAll(".reveal-on-scroll"));

const DESKTOP_WIDTH = 1024;
const SNAP_COOLDOWN_MS = 850;
const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

let isAutoScrolling = false;
let autoScrollTimeoutId = null;

function isDesktopViewport() {
  return window.innerWidth >= DESKTOP_WIDTH;
}

function prefersReducedMotion() {
  return reducedMotionQuery.matches;
}

function getSectionById(sectionId) {
  return document.getElementById(sectionId);
}

function getSectionTop(section) {
  return Math.max(section.offsetTop, 0);
}

function scrollToSection(sectionId) {
  const targetSection = getSectionById(sectionId);

  if (!targetSection) {
    return;
  }

  if (autoScrollTimeoutId) {
    window.clearTimeout(autoScrollTimeoutId);
  }

  isAutoScrolling = true;

  const maxScrollTop = Math.max(
    document.documentElement.scrollHeight - window.innerHeight,
    0
  );
  const targetTop = Math.min(getSectionTop(targetSection), maxScrollTop);

  window.scrollTo({
    top: targetTop,
    behavior: prefersReducedMotion() ? "auto" : "smooth",
  });

  autoScrollTimeoutId = window.setTimeout(function () {
    isAutoScrolling = false;
  }, SNAP_COOLDOWN_MS);
}

function getCurrentSectionIndex() {
  const pivot = window.scrollY + window.innerHeight * 0.35;
  let closestIndex = 0;
  let closestDistance = Number.POSITIVE_INFINITY;

  sections.forEach(function (section, index) {
    const distance = Math.abs(getSectionTop(section) - pivot);

    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = index;
    }
  });

  return closestIndex;
}

function setActiveSection(sectionId) {
  navLinks.forEach(function (link) {
    const isActive = link.getAttribute("data-section") === sectionId;
    link.classList.toggle("active", isActive);
  });
}

function updateActiveSection() {
  const scrollPosition = window.scrollY + window.innerHeight * 0.3;
  let activeSectionId = sections[0] ? sections[0].id : "";

  sections.forEach(function (section) {
    const top = getSectionTop(section);
    const bottom = top + section.offsetHeight;

    if (scrollPosition >= top && scrollPosition < bottom) {
      activeSectionId = section.id;
    }
  });

  if (activeSectionId) {
    setActiveSection(activeSectionId);
  }
}

function isScrollableElement(element, deltaY) {
  let current = element;

  while (current && current !== document.body) {
    const canScroll =
      current.scrollHeight > current.clientHeight &&
      window.getComputedStyle(current).overflowY !== "visible";

    if (canScroll) {
      const isScrollingDown = deltaY > 0;
      const atTop = current.scrollTop <= 0;
      const atBottom = current.scrollTop + current.clientHeight >= current.scrollHeight - 1;

      if ((isScrollingDown && !atBottom) || (!isScrollingDown && !atTop)) {
        return true;
      }
    }

    current = current.parentElement;
  }

  return false;
}

function handleSnapScroll(event) {
  if (!isDesktopViewport() || prefersReducedMotion() || isAutoScrolling) {
    return;
  }

  if (Math.abs(event.deltaY) < 45) {
    return;
  }

  if (isScrollableElement(event.target, event.deltaY)) {
    return;
  }

  const currentIndex = getCurrentSectionIndex();
  const direction = event.deltaY > 0 ? 1 : -1;
  const targetIndex = currentIndex + direction;

  if (targetIndex < 0 || targetIndex >= sections.length) {
    return;
  }

  event.preventDefault();
  scrollToSection(sections[targetIndex].id);
}

function activateTab(tabId, shouldFocus) {
  tabTriggers.forEach(function (trigger) {
    const isActive = trigger.getAttribute("data-tab") === tabId;
    trigger.classList.toggle("active", isActive);
    trigger.setAttribute("aria-selected", String(isActive));

    if (isActive && shouldFocus) {
      trigger.focus();
    }
  });

  tabPanels.forEach(function (panel) {
    panel.classList.toggle("active", panel.getAttribute("data-panel") === tabId);
  });
}

function setupRevealAnimations() {
  if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
    revealItems.forEach(function (item) {
      item.classList.add("is-visible");
    });
    return;
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.22,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  revealItems.forEach(function (item) {
    observer.observe(item);
  });
}

navLinks.forEach(function (link) {
  link.addEventListener("click", function (event) {
    event.preventDefault();
    scrollToSection(link.getAttribute("data-section"));
  });
});

window.addEventListener("scroll", updateActiveSection, { passive: true });
window.addEventListener("wheel", handleSnapScroll, { passive: false });
window.addEventListener("resize", updateActiveSection);

updateActiveSection();
setupRevealAnimations();
activateTab(
  (document.querySelector(".tabs-trigger.active") || tabTriggers[0])?.getAttribute("data-tab"),
  false
);

tabTriggers.forEach(function (trigger, index) {
  trigger.addEventListener("click", function () {
    activateTab(trigger.getAttribute("data-tab"), false);
  });

  trigger.addEventListener("keydown", function (event) {
    let nextIndex = index;

    if (event.key === "ArrowDown" || event.key === "ArrowRight") {
      nextIndex = (index + 1) % tabTriggers.length;
    } else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
      nextIndex = (index - 1 + tabTriggers.length) % tabTriggers.length;
    } else if (event.key === "Home") {
      nextIndex = 0;
    } else if (event.key === "End") {
      nextIndex = tabTriggers.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    activateTab(tabTriggers[nextIndex].getAttribute("data-tab"), true);
  });
});
